import React, { type JSX } from 'react'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import { ruleIconClassName } from 'modules/automation-rules/constants/automation-rule-icon-class'
import {
  AddTagIcon,
  CampaignSubscribeIcon,
  CampaignUnsubscribeIcon,
  CommunityIcon,
  CommunityUnenrollIcon,
  CourseBundleEnrollIcon,
  CourseBundleUnenrollIcon,
  CourseIcon,
  CourseUnenrollIcon,
  NewUserIcon,
  PipelineIcon,
  RemoveTagIcon,
  SendEmailIcon,
} from '@systemeio/ui/icons'
import { SmsIcon } from '@systemeio/ui/icons'

export const getActionIcon = (action: AutomationRuleActionsEnum): JSX.Element => {
  switch (action) {
    case AutomationRuleActionsEnum.add_tag:
      return <AddTagIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.remove_tag:
      return <RemoveTagIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.create_user:
    case AutomationRuleActionsEnum.create_white_label_user:
      return <NewUserIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.enroll_in_course:
      return <CourseIcon className={`fill-fill-primary ${ruleIconClassName}`} />
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return <CourseUnenrollIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
      return <CourseBundleUnenrollIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return <CourseBundleEnrollIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.send_email:
    case AutomationRuleActionsEnum.send_email_to_specific_address:
    case AutomationRuleActionsEnum.send_webhook:
      return <SendEmailIcon />
    case AutomationRuleActionsEnum.subscribe_to_campaign:
      return <CampaignSubscribeIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return <CampaignUnsubscribeIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.grant_access_to_community:
      return <CommunityIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return <CommunityUnenrollIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.assign_to_pipeline_stage:
      return <PipelineIcon className={ruleIconClassName} />
    case AutomationRuleActionsEnum.send_sms:
      return <SmsIcon className={ruleIconClassName} />
  }
}
